import i18n from '@connect-x-app/shared-translations';

import { isEmptyString } from '../strings';

export type ValidatorResponse = {
  isValid: boolean;
  message?: string;
};

export class FormValidator {
  maxLength(value: string, maxLength: number): ValidatorResponse {
    const isValid = value.length <= maxLength;

    return {
      isValid,
      message: isValid ? undefined : i18n.t('ERRORS.VALIDATION.MAX_LENGTH', { length: maxLength }),
    };
  }

  number(value: unknown): ValidatorResponse {
    const isValid = !Number.isNaN(Number(value));

    return {
      isValid,
      message: isValid ? undefined : i18n.t('FORM_VALIDATION.NUMBER.NAN'),
    };
  }

  required(value: unknown): ValidatorResponse {
    const isValid = !isEmptyString(`${value}`) && !!value;

    return {
      isValid: isValid,
      message: isValid ? undefined : i18n.t('FORM_VALIDATION.REQUIRED'),
    };
  }

  isAlphaNumeric(value: string, spaceAllowed = false): ValidatorResponse {
    const regex = spaceAllowed ? new RegExp(/^[a-z0-9\s]*$/gi) : new RegExp(/^[a-z0-9]*$/gi);
    const isValid = regex.test(value);

    return {
      isValid,
      message: isValid ? undefined : i18n.t('FORM_VALIDATION.REGEX.ALPHA_NUMERIC'),
    };
  }

  minValue(value: number, minValue: number): ValidatorResponse {
    if (!this.number(value).isValid) {
      return this.number(value);
    }

    const isValid = Number(value) >= minValue;

    return {
      isValid,
      message: isValid ? undefined : i18n.t('FORM_VALIDATION.NUMBER.MIN_VALUE', { minValue }),
    };
  }

  maxValue(value: number, maxValue: number): ValidatorResponse {
    if (!this.number(value).isValid) {
      return this.number(value);
    }

    const isValid = Number(value) <= maxValue;

    return {
      isValid,
      message: isValid ? undefined : i18n.t('FORM_VALIDATION.NUMBER.MAX_VALUE', { maxValue }),
    };
  }

  isInteger(value: string): ValidatorResponse {
    const regex = new RegExp(/^-?\d+$/);
    const isValid = regex.test(value);

    return {
      isValid,
      message: isValid ? undefined : i18n.t('FORM_VALIDATION.NUMBER.INTEGER'),
    };
  }

  dropdownRequired(value: number, itemName: string): ValidatorResponse {
    if (!this.number(value).isValid) {
      return this.number(value);
    }

    const isValid = Number(value) >= 1;

    return {
      isValid,
      message: isValid ? undefined : i18n.t('FORM_VALIDATION.DROPDOWN.REQUIRED', { itemName }),
    };
  }
}
